import styled from 'styled-components';

const BlockHeader = styled.h2(({ theme }) => {
  const { color, type } = theme;

  return `
    color: ${color.grayscale[0]};
    font-size: ${type.size.larger};
    font-weight: ${type.weight.bold};
    margin-bottom: 1.5rem;
  `;
});

export default BlockHeader;
